import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src/lib/gb-dashboard-shared-ui.module'

@Component({
  selector: 'gb-presenter-widget-raffle-item-label',
  standalone: true,
  imports: [TranslateModule, GbDashboardSharedUiModule],
  templateUrl: './gb-presenter-widget-raffle-item-label.component.html',
  styleUrl: './gb-presenter-widget-raffle-item-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterWidgetRaffleItemLabelComponent {
  raffleItemName = input<string | undefined>()
  isLaunchMode = input(false)

  showLabel = computed(() => !this.isLaunchMode() || !this.raffleItemName())
}
